import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Server02 = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size + 1} height={size} viewBox="0 0 17 16" fill="none">
      <path
        d="M14.9 4.4C14.9 5.72548 12.0346 6.8 8.49997 6.8C4.96535 6.8 2.09998 5.72548 2.09998 4.4M14.9 4.4C14.9 3.07452 12.0346 2 8.49997 2C4.96535 2 2.09998 3.07452 2.09998 4.4M14.9 4.4V11.6C14.9 12.9255 12.0346 14 8.49997 14C4.96535 14 2.09998 12.9255 2.09998 11.6V4.4M14.9 8C14.9 9.32548 12.0346 10.4 8.49997 10.4C4.96535 10.4 2.09998 9.32548 2.09998 8"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  )
})

export default Server02
